import { jsx as _jsx } from "react/jsx-runtime";
import { HStack, VStack } from "native-base";
import { formatDate } from "@madmedical/utils";
import AvatarTexts from "../AvatarTexts";
const SimpleAvatarListItem = ({ item }) => {
    const subText = [
        item.birthDate ? formatDate(item.birthDate) : null,
        "socialSecurityNumber" in item ? item.socialSecurityNumber : null,
    ]
        .filter((fragment) => !!fragment)
        .join(" | ");
    return (_jsx(HStack, Object.assign({ space: 4, justifyContent: "space-between", alignItems: "center", bgColor: "white", px: 4, py: 5.5, borderBottomColor: "gray.100", borderBottomWidth: 1, borderBottomStyle: "solid", width: "full" }, { children: _jsx(VStack, Object.assign({ width: "100%" }, { children: _jsx(AvatarTexts, { size: "xl", source: item.avatarUrl, initials: item.initials, label: item.fullName, subText: subText ? subText : undefined }) })) })));
};
export default SimpleAvatarListItem;
